import * as React from "react"
import { PaymentOptions } from "global"
let styles = require("./styles.module.scss")

export type TeslaToggleRadioProps = {
  labels: string[]
  teslaToggle: boolean
  updateFn?: (paymentOption: PaymentOptions) => void
}

export default class TeslaToggleRadio extends React.Component<
  TeslaToggleRadioProps
> {
  public static defaultProps: Partial<TeslaToggleRadioProps> = {
    // values: [true, false], // TODO we don't have "values" property
    labels: ["Yes", "No"],
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { updateFn } = this.props

    return (
      <div className={styles.toggle}>
        <div className={styles.header}>
          <p className={styles.subhead}>
            See how much you can save with a Solar Mortgage
            <sup className={styles.superscript}>TM</sup> compared to
          </p>
        </div>
        <div className={styles.wrapper}>
          <a
            className={styles.button}
            onClick={() => updateFn("financing")}
            data-js-toggle-financing
          >
            Financing
          </a>
          <a
            className={styles.button}
            onClick={() => updateFn("cash")}
            data-js-toggle-cash
          >
            Paying Cash
          </a>
        </div>
      </div>
    )
  }
}
